'AttachmentMaint'.maint({panelStyle: "titled", icon: 'Paperclip'})
'Add Attachment'.title({when: 'adding'})
'Edit Attachment'.title({when: 'editing'})
'Back'.action({act: 'cancel'})
'OK'.action({act: 'ok'})
'Save'.action({act: 'save'})
'Attachment'.datatype()

''.panel()
'datatype'.field({readOnly: true})
'theParentId'.field({hidden: true})
'parentReference'.field({readOnly: true})
'attachmentType'.field()
'description'.field()
'attachedDate'.field({date: true, readOnly: true})
'contents'.field()
'fileName'.field({readOnly: true})

'fileName'.visibleWhen((maint, attachment) => {
  return attachment.fileName ? true : false
})

'AttachmentMaint'.whenAdding(async function(attachment, maint) {
  let cast = maint.callerCast(); if ( ! cast ) return
  attachment.datatype = cast.datatype()
  attachment.theParentId = cast.id
})

'contents'.afterChoosingFile(async (maint, files) => {
  let attachment = maint.mainCast(); if ( ! attachment ) return
  if ( files.length !== 1 ) {
    maint.app().showMessage('Please select a single file')
    return
  }
  let f = files[0]
  let reader = new FileReader()
  reader.onload = function(e) {
    attachment.contents = btoa(e.target.result)
    attachment.__fileName = f.name
    attachment.fileName = f.name
  }
  reader.readAsBinaryString(f);
})


